import Widget from "./base.js";
import { NewsletterSignupBlock } from "./newsletter-signup-block.js";
import { setCookie, getCookie } from "tpm-utils";

// EmailWall — soft email gate on free articles (plan: tmp/emailwall-plan.md).
//
// PHP gates emission (themes/tpm25/inc/emailwall.php): the placeholder only
// exists on singular posts without `paywall` meta, with a more tag, in an
// allowlisted primary category (see EMAILWALL_CATEGORIES), for anon 
// (membership `none`) readers. This component owns presentation:
//
// - re-checks the category allowlist (defense in depth; mirrors the PHP const)
// - dismissible for 6h via a per-post cookie (`tpm_dismiss_emailwall_{postId}`);
//   the cookie is deliberately client-only: VIP cache variants do not key on
//   it, so the server must never vary output on it
// - a successful subscription does NOT dismiss the wall (the form's own
//   confirmation state shows inside it) — it only hides the shade, revealing
//   the content below 
//
// The signup UI is the existing NewsletterSignupBlock rendered as a child
// which composes NewsletterSignupForm for the actual subscribe flow.

const EMAILWALL_CATEGORIES = ["the-brief"];
const DISMISS_HOURS = 6;

export class EmailWall extends Widget {
	componentWillMount() {
		this.dismiss = this.dismiss.bind(this);
		this.hideShade = this.hideShade.bind(this);
		this.blurred = [];
	}

	cookieName() {
		return `tpm_dismiss_emailwall_${this.props.postId}`;
	}

	dismissed() {
		return getCookie(this.cookieName()) !== null;
	}

	eligible() {
		return EMAILWALL_CATEGORIES.includes(this.props.category);
	}

	// The dismiss button dismisses: 6h per-post cookie, wall unmounts.
	dismiss() {
		setCookie(this.cookieName(), "1", DISMISS_HOURS / 24);
		// this.unblur();
		this.setState({ dismissed: true });
	}

	// A successful subscription keeps the wall mounted (the form shows its own
	// confirmation inside it) and only lifts the shade off the content.
	hideShade() {
		const base = this.refs.base;
		if (!base) return;
		const shade = base.querySelector(".EmailWall__Shade");
		if (shade) shade.style.display = "none";
	}


	renderContent() {
		if (this.state.dismissed || this.dismissed() || !this.eligible()) return null;

		return (
			<div>
				<div className="EmailWall__Inner">
					<NewsletterSignupBlock
						category={this.props.category}
						categories={EMAILWALL_CATEGORIES}
						cssclasses="--emailwall --dark"
						onConfirmation={this.hideShade}
					/>
					<button className="EmailWall__Dismiss" onClick={this.dismiss}>
						No thanks
					</button>
				</div>
			</div>
		);
	}
}
